<div class="msgs">
  <!-- The page, what the current tab holds, and the one thing to do next -->
  <header class="msgs__head">
    <div class="msgs__intro">
      <p class="bk-eyebrow">SMS</p>
      <h1 class="bk-heading msgs__title">Messages</h1>
      <p class="msgs__sub">{{ description }}</p>
    </div>

    <div class="msgs__actions" (clickOutside)="onClickedOutside($event)">
      <ng-container
        *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'create-message-templates' }"
      >
        @if (activeTab === 'templates') {
          <button type="button" class="bk-btn bk-btn--primary" (click)="toggleContactDropDownTemplate()">
            <span class="bk-sym" aria-hidden="true">add</span>
            New template
          </button>
        }
      </ng-container>

      <ng-container *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'compose-sms' }">
        @if (activeTab !== 'templates') {
          <div class="msgs__create">
            <button
              #createTrigger
              id="msgs-create-trigger"
              type="button"
              class="bk-btn bk-btn--primary"
              aria-haspopup="menu"
              [attr.aria-expanded]="showCreateDropDown"
              [attr.aria-controls]="showCreateDropDown ? 'msgs-create-menu' : null"
              (click)="toggleCreateDropDown($event)"
              (keydown)="onCreateTriggerKeydown($event)"
            >
              New message
              <span class="bk-sym msgs__caret" aria-hidden="true">expand_more</span>
            </button>

            @if (showCreateDropDown) {
              <div
                #createMenu
                id="msgs-create-menu"
                class="msgs__menu"
                role="menu"
                aria-labelledby="msgs-create-trigger"
                (keydown)="onCreateMenuKeydown($event)"
              >
                <button type="button" role="menuitem" tabindex="-1" class="msgs__item" (click)="goToComposeMessage()">
                  <span class="bk-sym" aria-hidden="true">edit_square</span>
                  Compose message
                </button>
                <button type="button" role="menuitem" tabindex="-1" class="msgs__item" (click)="goToSmartBroadcast()">
                  <span class="bk-sym" aria-hidden="true">table_view</span>
                  Custom SMS
                </button>
              </div>
            }
          </div>
        }
      </ng-container>
    </div>
  </header>

  <!-- Tab navigation -->
  <app-routing-tab class="msgs__tabs" [tabList]="tabs" />

  <!-- Tab content -->
  <div class="msgs__body">
    <!-- Templates tab -->
    @if(activeTab === 'templates') {
      @if(template_data.length) {
        <message-template-table
          [startItem]="startItem_template"
          [endItem]="endItem_template"
          [meta]="meta_template"
          [loading]="loading"
          [template_data]="template_data"
        ></message-template-table>
      } @else if (loading) {
        <div class="bk-panel msgs__skel" aria-hidden="true">
          @for (row of [1, 2, 3, 4, 5]; track row) {
            <span class="bk-skel msgs__skel-row"></span>
          }
        </div>
      } @else {
        <div class="msgs__empty">
          <app-empty-state
            icon="messages"
            message="No templates yet."
            hint="Save copy you reuse as a template, then start any message from it."
            size="large"
          >
            <button
              *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'create-message-templates' }"
              type="button"
              class="bk-btn bk-btn--primary"
              (click)="toggleContactDropDownTemplate()"
            >
              <span class="bk-sym" aria-hidden="true">add</span>
              New template
            </button>
          </app-empty-state>
        </div>
      }
    }

    <!-- Active messages tab -->
    @if(activeTab === 'active') {
      <active-messages-table />
    }

    <!-- Inactive messages tab -->
    @if(activeTab === 'inactive') {
      <inactive-messages-table />
    }

    <!-- Archived messages tab -->
    @if(activeTab === 'archived') {
      <archived-messages-table />
    }
  </div>
</div>
